var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"space-container"},_vm._l((_vm.spaces),function(item,index){return _c('span',{key:index,staticClass:"space"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }